import legacyIsDesktop from 'helpers/legacyIsDesktop';

export default function resizeBackground (img) {
  let styleString = '';
  if (window.innerWidth < window.innerHeight) {
    styleString = 'width: auto; height: 100%;';
  } else {
    styleString = 'width: 100%; height: auto;';
  }
  if (img.clientHeight < window.innerHeight ) {
    styleString = 'width: auto; height: 100%;';
  }
  if (img.clientWidth < window.innerWidth ) {
    styleString = 'width: 100%; height: auto;';
  }

  if (!legacyIsDesktop()) {
    styleString = 'transform:translateX(-25%);';
  }

  img.setAttribute('style', styleString);
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/sliders/resizeBackground.js